/* eslint-disable import/prefer-default-export */
export { mediaQueries, breakpoints } from "./cssUtils";

export const FIELD_REQUIRED_MESSAGE = "This field is required";
